import React, { PureComponent } from 'react';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from 'modules/admin';

const muiThemeStyles = theme => ({
  textField: theme.textField,
  button: theme.button,
  Input: theme.Input,
  input: theme.input
});

export class Search extends PureComponent {
  handleInputOrderId = (e) => {
    this.props.updateOrderIdSearchText(e.target.value.replace(/\D+/g, ''));
  }

  handleInputUserEmailSearchText = (e) => {
    this.props.updateUserEmailSearchText(e.target.value);
  }

  handleInputUserFirstNameSearchText = (e) => {
    this.props.updateUserFirstNameSearchText(e.target.value);
  }

  handleInputUserLastNameSearchText = (e) => {
    this.props.updateUserLastNameSearchText(e.target.value);
  }

  handleKeyDown = (e) => {
    if (e.charCode === 13) {
      this.props.search();
    }
  }

  render() {
    const {
      classes,
      errorMessage,
      loading,
      orderIdSearchText,
      userEmailSearchText,
      userFirstNameSearchText,
      userLastNameSearchText
    } = this.props;

    return (
      <Grid item xs={12}>
        <Typography variant="headline">Refunds: Search by Order Id, Email or User Name</Typography>
        { errorMessage.length ? <Typography variant="body1" style={{ color: 'red' }}>{ errorMessage }</Typography> : null }
        <Grid container direction="column" spacing={0} style={{ margin: '16px 0' }}>
          <Grid item xs={4}>
            <TextField
              className={classes.textField}
              InputProps={{ className: classes.Input }}
              inputProps={{ className: classes.input, id: 'orderId' }}
              name="orderId"
              placeholder="Order ID"
              value={orderIdSearchText}
              onChange={this.handleInputOrderId}
              onKeyPress={this.handleKeyDown}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              className={classes.textField}
              InputProps={{ className: classes.Input }}
              inputProps={{ className: classes.input, id: 'userEmail' }}
              name="userEmail"
              placeholder="Email"
              value={userEmailSearchText}
              onChange={this.handleInputUserEmailSearchText}
              onKeyPress={this.handleKeyDown}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              className={classes.textField}
              InputProps={{ className: classes.Input }}
              inputProps={{ className: classes.input, id: 'firstName' }}
              placeholder="First Name"
              name="firstName"
              value={userFirstNameSearchText}
              onChange={this.handleInputUserFirstNameSearchText}
              onKeyPress={this.handleKeyDown}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              className={classes.textField}
              InputProps={{ className: classes.Input }}
              inputProps={{ className: classes.input, id: 'lastName' }}
              placeholder="Last Name"
              name="lastName"
              value={userLastNameSearchText}
              onChange={this.handleInputUserLastNameSearchText}
              onKeyPress={this.handleKeyDown}
            />
          </Grid>
          <Button
            color="primary"
            disabled={loading}
            onClick={this.props.search}
          >Search
          </Button>
        </Grid>
      </Grid>
    );
  }
}

Search.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  errorMessage: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  orderIdSearchText: PropTypes.string.isRequired,
  userEmailSearchText: PropTypes.string.isRequired,
  userFirstNameSearchText: PropTypes.string.isRequired,
  userLastNameSearchText: PropTypes.string.isRequired,
  updateOrderIdSearchText: PropTypes.func.isRequired,
  updateUserEmailSearchText: PropTypes.func.isRequired,
  updateUserFirstNameSearchText: PropTypes.func.isRequired,
  updateUserLastNameSearchText: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  loading: state.admin.loading,
  errorMessage: state.admin.errorMessage,
  orderIdSearchText: state.admin.orderIdSearchText,
  userEmailSearchText: state.admin.userEmailSearchText,
  userFirstNameSearchText: state.admin.userFirstNameSearchText,
  userLastNameSearchText: state.admin.userLastNameSearchText
});

const mapDispatchToProps = dispatch => ({
  updateOrderIdSearchText: (text) => {
    dispatch(actions.updateOrderIdSearchText(text));
  },
  updateUserEmailSearchText: (text) => {
    dispatch(actions.updateUserEmailSearchText(text));
  },
  updateUserFirstNameSearchText: (text) => {
    dispatch(actions.updateUserFirstNameSearchText(text));
  },
  updateUserLastNameSearchText: (text) => {
    dispatch(actions.updateUserLastNameSearchText(text));
  },
  search: () => {
    dispatch(actions.search());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(muiThemeStyles)(Search));



// WEBPACK FOOTER //
// ./routes/Orders/containers/Refunds/containers/Search/index.jsx